import * as React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Divider from '@mui/material/Divider';
import { DatePicker } from '@fluentui/react';
import Checkbox from '@mui/material/Checkbox';
import { FormControlLabel } from '@material-ui/core';
import { BpCheckedIcon, BpIcon } from '../../components/common/CheckboxWrapper';
import { DefaultButton } from '@fluentui/react/lib/Button';
import Select from 'react-select';
import moment from 'moment';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';
import { baseFontFamilyStyle } from '../../shared/styles';

export const saveAttachment = result => {
	return new Promise((resolve, reject) => {
		Office.context.mailbox.item.getAttachmentContentAsync(result.id, resp => {
			resolve(resp);
		});
	});

	return;

	function __base64ToArrayBuffer(base64) {
		var atob = require('atob');
		//  base64 =base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, '')
		var binary_string = atob(base64);
		var len = binary_string.length;
		var bytes = new Uint8Array(len);
		for (var i = 0; i < len; i++) {
			bytes[i] = binary_string.charCodeAt(i);
		}
		return bytes;
	}

	const downloadFileLocally = mailItemContent => {
		var FileSaver = require('file-saver');
		let text = mailItemContent.value.content;
		text = text.replaceAll('&#xd;', '');
		const byteArray = __base64ToArrayBuffer(text);
		let blob = new Blob([byteArray]);
		//  FileSaver.saveAs(blob, result.name);
	};
};

export const downloadAttachmentLocally = mailItemContent => {
	// var FileSaver = require("file-saver");
	let text = mailItemContent.value.content;
	text = text.replaceAll('&#xd;', '');
	function __base64ToArrayBuffer(base64) {
		var atob = require('atob');
		//  base64 =base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, '')
		var binary_string = atob(base64);
		var len = binary_string.length;
		var bytes = new Uint8Array(len);
		for (var i = 0; i < len; i++) {
			bytes[i] = binary_string.charCodeAt(i);
		}
		return bytes;
	}
	const byteArray = __base64ToArrayBuffer(text);
	let blobAttachment = new Blob([byteArray]);

	//  FileSaver.saveAs(blobAttachment, mailItemContent.name);
	return blobAttachment;
};

export const SaveAttachments = props => {
	const [selectedOptions, setSelectedOptions] = React.useState();
	const [open, setOpen] = React.useState(true);
	const { currentOfficeTheme, showDialogForAttachment, setCallBackForShowDialog } = props;

	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
	const loaderStyles = {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
		flex: 1,
		height: '200px',
		width: '200px',
	};

	React.useEffect(() => {
		setOpen(showDialogForAttachment);
	}, [props]);

	// Function triggered on selection
	function handleSelect(data) {
		setSelectedOptions(data);
	}

	const rowStyle = {
		fontFamily: baseFontFamilyStyle,
		fontSize: '13px',
	};

	const customStyles = {
		control: (provided, state) => ({
			...provided,
			minHeight: 'auto',
			minWidth: '250px',
			backgroundColor: currentOfficeTheme.bodyBackgroundColor,
		}),
		valueContainer: (provided, state) => ({
			...provided,
			minHeight: 'auto',
			minWidth: 'auto',
			backgroundColor: currentOfficeTheme.bodyBackgroundColor,
			color: currentOfficeTheme.bodyForegroundColor,
		}),
		placeholder: (provided, state) => ({
			...provided,
			color: currentOfficeTheme.bodyForegroundColor,
		}),
		menuList: base => ({
			...base,
			backgroundColor: currentOfficeTheme.bodyBackgroundColor,
			color: currentOfficeTheme.bodyForegroundColor,
		}),
		input: (provided, state) => ({
			...provided,
			color: currentOfficeTheme.bodyForegroundColor,
		}),

		dropdownIndicator: styles => ({
			...styles,
			backgroundColor: currentOfficeTheme.bodyBackgroundColor,
			color: currentOfficeTheme.bodyForegroundColor,
		}),

		option: (base, { data, isDisabled, isFocused, isSelected }) => {
			return {
				...base,
				backgroundColor: data && currentOfficeTheme.bodyBackgroundColor,
				color: data && currentOfficeTheme.bodyForegroundColor,
			};
		},
		multiValue: base => ({
			...base,
			backgroundColor: currentOfficeTheme.bodyBackgroundColor,
		}),
		multiValueLabel: base => ({
			...base,
			color: currentOfficeTheme.bodyForegroundColor,
		}),
	};

	const columnStyle = {
		margin: '10px 0px 0px 10px',
		fontSize: '11px',
	};

	const datePickerStyles = {
		textField: {
			'& .ms-Label': {
				color: currentOfficeTheme.bodyForegroundColor,
			},
			'& .ms-TextField-fieldGroup': {
				backgroundColor: currentOfficeTheme.bodyBackgroundColor,
				color: currentOfficeTheme.bodyForegroundColor,
				':after': {
					borderColor: 'transparent',
				},
			},
			'& .ms-TextField-field': {
				color: currentOfficeTheme.bodyForegroundColor,
			},
		},
		icon: {
			color: currentOfficeTheme.bodyForegroundColor,
		},
	};

	const handleClose = () => {
		setOpen(false);
		setCallBackForShowDialog();
	};

	return (
		<>
			<Dialog open={open} onClose={handleClose} fullScreen={fullScreen}>
				<DialogContent style={{ backgroundColor: currentOfficeTheme.bodyBackgroundColor }}>
					{true ? (
						<div style={loaderStyles}>
							<Spinner size={SpinnerSize.large} label="Almost there..." />
						</div>
					) : (
						<div className="container" style={{ color: currentOfficeTheme.bodyForegroundColor }}>
							<div className="row" style={rowStyle}>
								<div className="column" style={{ fontWeight: 'bold' }}>
									Download Selected Files
								</div>
								<div className="column" style={columnStyle}>
									selecting OK will extract the selected documents.
								</div>
								<div className="column" style={columnStyle}>
									When the process is complete, you will receive an email containing a link to
									selected package.
								</div>
							</div>
							<Divider style={{ margin: '15px 0px 15px 0px' }} />

							<div className="row" style={{ display: 'flex', flexDirection: 'row' }}>
								<div className="column" style={{ margin: '0px 5px 10px 0px' }}>
									<FormControlLabel
										sx={{
											fontFamily: baseFontFamilyStyle,
											'& .MuiTypography-body1': {
												lineHeight: 0,
											},
										}}
										control={<Checkbox icon={<BpIcon />} checkedIcon={<BpCheckedIcon />} />}
										label={
											<span
												style={{
													fontSize: '12px',
													fontWeight: 'bold',
													fontFamily: baseFontFamilyStyle,
												}}
											>
												Include All Revisions
											</span>
										}
									/>
								</div>
								<div
									className="column"
									style={{ fontSize: '12px', marginBottom: '5px', fontWeight: 'bold' }}
								>
									Set Link Expiration Date
								</div>
								<div className="column" style={{ fontSize: '13px', marginBottom: '5px' }}>
									<DatePicker
										required={true}
										showWeekNumbers={true}
										firstWeekOfYear={1}
										showMonthPickerAsOverlay={true}
										styles={datePickerStyles}
										maxDate={new Date(moment().add(1, 'month'))}
										minDate={new Date()}
										label=""
										id="date"
										autoAdjustHeight
										placeholder="Select a date..."
										showGoToToday
										ariaLabel="Select a date"
										value={new Date()}
									/>
								</div>
							</div>
							<div style={{ alignItems: 'center', width: '100%', marginBottom: '50px' }}>
								<Select
									options={[]}
									placeholder="Select Contact"
									value={selectedOptions}
									onChange={handleSelect}
									isSearchable={true}
									isMulti
									styles={customStyles}
								/>
							</div>
						</div>
					)}
				</DialogContent>
				<DialogActions style={{ backgroundColor: currentOfficeTheme.bodyBackgroundColor }}>
					<DefaultButton
						text="Cancel"
						onClick={handleClose}
						style={{
							backgroundColor: currentOfficeTheme.bodyBackgroundColor,
							color: currentOfficeTheme.bodyForegroundColor,
						}}
					/>
					<DefaultButton
						text="OK"
						onClick={handleClose}
						allowDisabledFocus
						size="small"
						content="Small"
						style={{
							backgroundColor: currentOfficeTheme.bodyForegroundColor,
							color: currentOfficeTheme.bodyBackgroundColor,
						}}
					/>
				</DialogActions>
			</Dialog>
		</>
	);
};
